import { render } from "./BizTeamPanel.vue?vue&type=template&id=6255a754&scoped=true"
import script from "./BizTeamPanel.vue?vue&type=script&lang=js"
export * from "./BizTeamPanel.vue?vue&type=script&lang=js"

import "./BizTeamPanel.vue?vue&type=style&index=0&id=6255a754&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6255a754"]])

export default __exports__